import styled from 'styled-components'
  const NavigationBox = styled.div`
  text-align: ${props =>
    props.center ? 'center' : props.align ? props.align : 'left'};
  @media (min-width: 40em) {
  }
`;

export default NavigationBox